import React from "react";
import Skeleton from "react-loading-skeleton";

const DashboardSkeleton = () => {
  return (
    <div className="w-screen h-screen md:h-screen max-w-screen max-h-dvh bg-primary-50 md:p-4 flex flex-col relative overflow-hidden no-scrollbar gap-2">
      {/* Top Skeleton Bar */}
      <div className="bg-glass-skeleton h-12 md:h-6 w-full"></div>

      {/* Main Content Area */}
      <div className="flex gap-2 w-full h-full flex-1 max-h-full overflow-hidden no-scrollbar bg-neutral-10 md:p-4 md:rounded-xl">
        {/* Sidebar (Visible on md+) */}
        <div className="hidden md:flex gap-4   min-w-[100px] flex-col p-1">
          <div className="bg-glass-skeleton h-[100px] w-full"></div>
          <div className="bg-glass-skeleton h-full w-full"></div>
        </div>

        {/* Main Content Skeleton */}
        <div className="w-full   flex gap-2 p-2 ">
          <div className="bg-glass-skeleton h-full w-full"></div>
        </div>
      </div>

      {/* Footer Skeleton (Visible on md+) */}
      <div className="hidden md:block">
        <Skeleton height={20} />
      </div>
    </div>
  );
};

export default DashboardSkeleton;
